<p>quote-management works!</p>
